export enum CARD_BADGES {
    USED_IN_COURSE = 'in-course',
    USED_IN_LESSON = 'in-lesson',
}
